// extracted by mini-css-extract-plugin
module.exports = {"leg":"leg-3uu2e","header__cities":"header__cities-2McDe"};